import { useState } from 'react';
import { ResultResourceData } from 'framework/crud';
import { useProjectService } from 'domain/shared/project';
import { useInputHelper, LoadDropdown, Option } from 'framework/form';

interface Props {
  source: string;
  label?: string;
  showLoader?: boolean;
  placeholder?: string;
  disabled?: boolean;
  isVisible?: boolean | ((data: any) => boolean);
  loadDataMethod?: () => ResultResourceData;
  mapResults?: (data: any) => Option;
}

const JournalEntryProjectDropdown = ({
  loadDataMethod,
  mapResults: mapResultsFromProps,
  disabled,
  ...props
}: Props) => {
  const { searchAllSuggestions } = useProjectService();
  const { getRawOnChangeCallback } = useInputHelper(props);
  const rawOnChangeCallback = getRawOnChangeCallback();
  const [loadedProjects, setLoadedProjects] = useState<any[]>([]);

  const loadProjectSuggestions = async () => {
    const projects = await searchAllSuggestions({});

    setLoadedProjects(projects);

    projects.unshift({
      id: 'no-specific-project',
      projectName: 'No specific project',
    });

    return {
      result: projects,
    };
  };

  const onChangeCallback = (values: any) => {
    const projectId = values[props.source];
    const projectData = projectId ? loadedProjects.find(data => data.id === projectId) : {};

    if (rawOnChangeCallback) {
      rawOnChangeCallback({ project: { projectId, accountId: projectData.accountId, sowId: projectData.sowId } });
    }
  };

  return (
    <LoadDropdown
      label="Project"
      placeholder="Select project"
      loadDataMethod={loadProjectSuggestions}
      onChangeCallback={onChangeCallback}
      isVisible={(data: any) => data.projectIsRequired}
      mapResults={(project: ResultResourceData) => ({
        value: project.id,
        accountId: project.accountId,
        sowId: project.sowId,
        label: `${project.projectName} ${project.sowId ? `(SOW Number: ${project.sowId})` : ''}`,
      })}
      {...props}
    />
  );
};

export default JournalEntryProjectDropdown;
